/**
 * The tutorial system's public surface. Application code imports from here and
 * never reaches into `engine/` or `definitions/`.
 *
 * Typical uses:
 *   <TutorialProvider>…</TutorialProvider>          once, inside the router
 *   const { isActive, start } = useTutorial()       to offer or drive a tutorial
 *   const locked = useTutorialLock('editor')        to make a field inert
 *   tutorialBus.emit('situation:added', {…})        to report that something happened
 *   {...tutorialAttr(TUTORIAL_TARGETS.CANVAS)}      to make an element targetable
 */

import React from 'react';
import { TutorialProvider as TutorialStateProvider } from './engine/TutorialContext';
import TutorialLayer from './ui/TutorialLayer';

/** State plus the overlay it draws. Mount once, inside the router. */
export const TutorialProvider = ({ children }) => (
    <TutorialStateProvider>
        {children}
        <TutorialLayer />
    </TutorialStateProvider>
);

export { useTutorial, useTutorialLock } from './engine/TutorialContext';
export { default as tutorialBus } from './engine/tutorialBus';
export { default as useRegisterTutorialActions } from './engine/useRegisterTutorialActions';
export { default as TutorialCanvasBridge } from './engine/TutorialCanvasBridge';
export { default as TutorialPromptModal } from './ui/TutorialPromptModal';
export { TUTORIAL_TARGETS, tutorialAttr } from './targets';
export { default as tutorialRegistry, CREATE_BASICS, replayableTutorials } from './registry';
